(() => {
  if (window.fitorbUSReviewsInitialized) return;
  window.fitorbUSReviewsInitialized = true;
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function card(review) {
    const article = el('article', 'fit-reviews__card');
    article.dataset.reviewId = review.id;
    for (const url of review.images) {
      const link = el('a'); link.href = url; link.target = '_blank'; link.rel = 'noopener';
      const image = el('img'); image.src = url; image.alt = `Customer photo: ${review.name}`;
      image.loading = 'lazy'; image.width = 600; image.height = 600;
      link.append(image); article.append(link);
    }
    const body = el('div', 'fit-reviews__body');
    body.append(el('h3', '', review.name));
    const stars = el('span', 'fit-reviews__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
    stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
    body.append(stars);
    if (review.title) body.append(el('h4', '', review.title));
    if (review.text) body.append(el('p', '', review.text));

    article.append(body); return article;
  }
  function init(root = document) {
    root.querySelectorAll('[data-fit-reviews]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const grid = section.querySelector('[data-review-grid]');
      const button = section.querySelector('[data-review-more]');
      const status = section.querySelector('[data-review-status]');
      let reviews;
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          if (!reviews) {
            const response = await fetch(section.dataset.source);
            if (!response.ok) throw new Error('Review data unavailable');
            const data = await response.json(); reviews = data.reviews;
          }
          const shown = grid.children.length;
          const batch = reviews.slice(shown, shown + 12);
          const fragment = document.createDocumentFragment(); batch.forEach(review => fragment.append(card(review)));
          grid.append(fragment);
          status.textContent = `${grid.children.length.toLocaleString('en-US')} of ${reviews.length.toLocaleString('en-US')} reviews`;
          button.hidden = grid.children.length >= reviews.length;
        } catch (_) {
          status.textContent = 'Could not load reviews. Please try again.';
        } finally { button.disabled = false; }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

